"use client";

import React from "react";
import { Building2, ArrowLeft, HeartPulse } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocationsAndPavilionsInAshkelon() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="מיקומים-וביתנות-באשקלון" className="py-16 md:py-24 bg-background overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start space-y-6 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Badge variant="secondary" className="gap-1.5 px-3 py-1 text-sm">
              <Building2 className="w-4 h-4" />
              <span>מרכזים רפואיים באשקלון</span>
            </Badge>

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground leading-tight">
              המרכז הרפואי ברזילי
            </h2>

            <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
              <p>
                המרכז הרפואי ברזילי באשקלון מהווה עוגן בריאותי מרכזי עבור תושבי העיר והסביבה. בית החולים מציע מגוון רחב של שירותים רפואיים מתקדמים, מחלקות אשפוז מודרניות, וצוות רפואי מסור ומקצועי. בין אם מדובר בטיפולי חירום, רפואת נשים ויולדות, כירורגיה או רפואת ילדים, ברזילי מספק מענה מקיף ואיכותי לכל מטופל.
              </p>
              <p>
                בשנים האחרונות, המרכז הרפואי עבר תנופת פיתוח משמעותית, הכוללת הקמת מבנים חדשים, שדרוג תשתיות קיימות והצטיידות בטכנולוגיות רפואיות מהשורה הראשונה. בית החולים פועל בשיתוף פעולה הדוק עם הקהילה ומקדם תוכניות מניעה וקידום אורח חיים בריא.
              </p>
              <p>
                אנו מבינים את החשיבות של טיפול רפואי נגיש ואיכותי קרוב לבית. לכן, אנו גאים להציג את השירותים השונים הניתנים במרכז הרפואי ברזילי, ולסייע לכם לנווט בין המחלקות והמרפאות השונות לקבלת הטיפול המיטבי.
              </p>
            </div>

            <div className="pt-6">
              <Button asChild size="lg" className="group rounded-lg">
                <Link to="/ServicesCitiesArticlesPage">
                  למידע נוסף על שירותים באזור
                  <ArrowLeft className="w-5 h-5 mr-2 transition-transform group-hover:-translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border/50 group">
              <AspectRatio ratio={4 / 3}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/barzilai_medical_center_ashkelon.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/barzilai_medical_center_ashkelon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/barzilai_medical_center_ashkelon.png-wvc-sizes" alt="המרכז הרפואי ברזילי באשקלון" className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              </AspectRatio>
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" />
            </div>

            {}
            <div className="absolute -bottom-6 -right-6 md:-right-8 bg-card p-5 rounded-xl shadow-xl border border-border flex items-center gap-4 z-10">
              <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                <HeartPulse className="w-6 h-6 text-primary" />
              </div>
              <div>
                <p className="text-sm text-muted-foreground font-medium">שירות רפואי</p>
                <p className="text-lg font-bold font-default text-foreground">מתקדם ומקצועי</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}